import api from './api';

export interface User {
  id: number;
  username: string;
  email: string;
  user_type: 'admin' | 'client' | 'sub';
  status: 'active' | 'disabled';
  client_id: number;
  parent_id?: number;
  created_at: string;
  updated_at: string;
}

export interface SubAccountListParams {
  page?: number;
  size?: number;
  status?: 'active' | 'disabled';
  keyword?: string;
  client_id?: number;
}

export interface SubAccountListResponse {
  list: User[];
  total: number;
  page: number;
  size: number;
}

export interface CreateSubAccountRequest {
  username: string;
  email: string;
  password: string;
  client_id: number;
}

export interface UpdateSubAccountRequest {
  id: number;
  username?: string;
  email?: string;
  status?: 'active' | 'disabled';
}

class UserService {
  // 获取子账号列表
  async getSubAccounts(params: SubAccountListParams): Promise<SubAccountListResponse> {
    const response = await api.post('/api/client/sub-accounts/list', params);
    return response.data.data; // 修复：正确访问 data.data
  }

  // 创建子账号
  async createSubAccount(data: CreateSubAccountRequest): Promise<{ message: string; user: User }> {
    const response = await api.post('/api/client/sub-accounts/create', data);
    return response.data.data; // 修复：正确访问 data.data
  }

  // 更新子账号
  async updateSubAccount(data: UpdateSubAccountRequest): Promise<{ message: string }> {
    const response = await api.post('/api/client/sub-accounts/update', data);
    return response.data.data; // 修复：正确访问 data.data
  }

  // 删除子账号
  async deleteSubAccount(userId: number): Promise<{ message: string }> {
    const response = await api.post('/api/client/sub-accounts/delete', { user_id: userId });
    return response.data.data; // 修复：正确访问 data.data
  }

  // 切换子账号状态
  async toggleSubAccount(userId: number): Promise<{ message: string }> {
    const response = await api.post('/api/client/sub-accounts/toggle', { user_id: userId });
    return response.data.data; // 修复：正确访问 data.data
  }

  // 获取子账号详情
  async getSubAccountDetail(userId: number): Promise<User> {
    const response = await api.post('/api/client/sub-accounts/detail', { user_id: userId });
    return response.data.data; // 修复：正确访问 data.data
  }
}

export const userService = new UserService();